<template>
  <InfoCard
    id="awaitingTenantDevices"
    :value="count"
    title="Assign Tenant Device"
    icon="fas fa-user-clock"
    :color="color"
    :loading="loading"
    :details="details"
    @click="$emit('click', $event)"
  />
</template>

<script>
import InfoCard from "./InfoCard.vue";

export default {
  name: "CardMissingTenantDevices",
  components: { InfoCard },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: true,
    },
    details: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
